import PageHeader from "app/shared/PageHeader";
import "./Flights.scss";
import CustomReconTabs from "../Reconcilation/components/CustomReconTabs";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { tabViewStates, userInfo } from "app/config/States/users";

import FlightRecon from "./components/FlightRecon";
export default function VatDemo(props: any) {
  const [activeTab, setActiveTab] = useState("1");
  const [userDetails, _] = useRecoilState<any>(userInfo);

  return (
    <div className="Flights">
      <div className="ScreenContainer">
        <PageHeader title="VAT" />

        <div className="TableContainer">{<FlightRecon />}</div>
      </div>
    </div>
  );
}
